import React from 'react';
import BaseSelectroPresenter, {
  type selectroPresenterBasePropsParams,
} from './BaseSelectroPresenter';
import {
  type SelectroTemplates,
  type SelectroText,
  type SelectroV2Props,
} from '@aha-app/selectro-v2';
import UserItemTemplate from '../Templates/Users/UserItemTemplate';
import UserTriggerItems from '../Templates/Users/UserTriggerItems';

// This is the definition for the users SelectroPresenter,
// to use it import UserSelectroPresenter from SelectroPresenters/index.ts
// that file exports the singleton instance of this class.
class UsersSelectroPresenterDefinition extends BaseSelectroPresenter {
  baseTemplates(): SelectroTemplates {
    return {
      item: UserItemTemplate,
      triggerItems: () => <UserTriggerItems />,
    };
  }

  baseText(): SelectroText {
    return {
      searchPlaceholder: 'Search by name or email',
    };
  }

  baseProps(params?: selectroPresenterBasePropsParams): SelectroV2Props {
    return {
      ...super.baseProps(params),
      searchFields: ['text', 'email'],
      centeredItemContent: true,
    };
  }
}

export default UsersSelectroPresenterDefinition;
